const options = {
  5: "bg-lime-400/5",
  10: "bg-lime-400/10",
  25: "bg-lime-400/25",
  50: "bg-lime-400/50",
  75: "bg-lime-400/75",
  90: "bg-lime-400/90",
  100: "bg-lime-400",
};

const from = {
  5: "from-lime-400/5",
  10: "from-lime-400/10",
  25: "from-lime-400/25",
  50: "from-lime-400/50",
  75: "from-lime-400/75",
  90: "from-lime-400/90",
  100: "from-lime-400",
};

export default function getBackgroundLime400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
